import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full relative" }
const _hoisted_2 = {
  key: 0,
  class: "text-[10px] text-gray-600 mt-1"
}

import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/solid";
import { ref } from 'vue';
import TextInput from '@/components/inputs/TextInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    id: {
        type: String,
        default: null,
    },
    autocomplete: {
        type: String,
        default: "current-password",
    },
    placeholder: {
        type: String,
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    helper: {
        type: String,
        default: null,
    },
    error: {
        type: String,
        default: null,
    },
},
  setup(__props) {



const showPassword = ref<boolean>(false);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TextInput, {
      modelValue: __props.modelValue,
      label: __props.label,
      placeholder: __props.placeholder,
      type: showPassword.value ? 'text' : 'password',
      id: __props.id,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      autocomplete: __props.autocomplete
    }, {
      password: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showPassword.value = !showPassword.value)),
          class: "cursor-pointer absolute inset-y-0 right-0 pr-3 flex items-center"
        }, [
          (showPassword.value)
            ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                key: 0,
                class: "h-5 w-5 text-primary-500",
                "aria-hidden": "true"
              }))
            : (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                key: 1,
                class: "h-5 w-5 text-primary-500",
                "aria-hidden": "true"
              }))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "label", "placeholder", "type", "id", "autocomplete"]),
    (__props.helper)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.helper), 1))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})